import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import reportApi from "../../../api/report";
import productApi from "../../../api/product";

const defaultState = () => ({
    dataProduct: [{
        product_id: 0,
        product_code: "Pilih Produk",
        product_name: "Cari dengan menggunakan kode produk"
    }],
    dataSummary:{
        totalSales: 0,
        totalSalesBase: 0,
        totalSalesDiff: 0,
    },
    dataAnalysis: [],
    dataSalesReport: [],
    dataPenjualan: [],
    pagination: {},
    detailPenjualan: {},
    rincianLaporan: [],
    productSelling: [],
    mitraBaru: []
});

const state = defaultState();

const getters = {
    buyerChartData() {
        let product = [
            ['Status', 'Qty', { role: "style" }]
        ]
        let color = ['#563A9C', '#8B5DFF', '#FFCF81', '#FDFFAB', '#87A2FF', '#C4D7FF', '#50B498', '#9CDBA6', '#C13131', '#FF5B44']
        state.productSelling.forEach((element, index) => {
            product.push([element.product_name, parseInt(element.total), color[index]])
        });
        return product
    },
};

const mutations = {
    listDataPenjualan(state, data) {
        state.pagination = {}
        state.dataPenjualan = []
        state.rincianLaporan = []
        state.productSelling = []
        state.dataPenjualan = data.data;
        state.rincianLaporan = data.summary;
        state.productSelling = data.product;
        state.pagination = data.pagination;
    },
    listMitraBaru(state, data) {
        state.pagination = {}
        state.mitraBaru = []
        state.mitraBaru = data.data;
        state.pagination = data.pagination;
    },
    listDetailPenjualan(state, data) {
        state.detailPenjualan = data;
    },
    listSalesReport(state, data) {
        state.pagination = {}
        state.dataSalesReport = []
        state.productSelling = []
        state.dataSummary.totalSales = 0
        state.dataSummary.totalSalesBase = 0
        state.dataSummary.totalSalesDiff = 0
        state.dataSalesReport = data.data
        state.productSelling = data.product;
        state.pagination = data.pagination
        state.dataSummary.totalSales = data.summary.total_sales_price ? data.summary.total_sales_price : 0
        state.dataSummary.totalSalesBase = data.summary.total_sales_price_original ? data.summary.total_sales_price_original : 0 
        state.dataSummary.totalSalesDiff = data.summary.total_sales_diff ? data.summary.total_sales_diff : 0
    },
    listProduct(state, data){
        state.dataProduct = state.dataProduct.concat(data.data.results)
    },
    listAnalysis(state, data){
        state.dataAnalysis = []
        //console.log(Object.keys(state.dataAnalysis).length);
        state.dataAnalysis = data.data
        //console.log(Object.keys(state.dataAnalysis).length);
    }
};
const actions = {

    getLaporanPenjualan({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getTransactionData(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataPenjualan', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listDataPenjualan", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getTransactionData({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataPenjualan', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listDataPenjualan", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
    getDetailPenjualan({ commit }, params) {
        commit("listDetailPenjualan", {});
        commit(PROGRESS_START, null, { root: true });
        reportApi.getTransactionDetail(params).then(({ data: { data } }) => {
            commit("listDetailPenjualan", data);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },

    getMitraBaru({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getRegisterData(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listMitraBaru', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listMitraBaru", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getRegisterData({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listMitraBaru', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listMitraBaru", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },

    getSalesReport({ commit }, value){
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getSalesReport(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listSalesReport', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {    
                    commit("listSalesReport", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getSalesReport({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listSalesReport', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listSalesReport", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary});
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },

    getSalesAnalysis({ commit }, value){
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"date_type": "${value.dateType}","product_code": "${value.productCode}","date": "${value.dateRange}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getSalesAnalysis(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listAnalysis', { data: 'error' });
                } else {
                    commit("listAnalysis", { data: data.results  });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getSalesAnalysis({ 'date_type': value.dateType }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listAnalysis', { data: 'error' });
                } else {
                    commit("listAnalysis", { data: data.results });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },

    getProduct({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        productApi.getDataProduct(params).then(({ data }) => {
            commit("listProduct", data);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};